/* eslint-disable */
import { addSpaceToNumber } from "../../utils/utils";
import React, { FC, useEffect, useRef, useState } from "react";

import "./floatingInput.scss";

interface IFloatInputProps {
  type: string;
  name?: string;
  labelName: string;
  id?: string;
  className?: string;
  onChange: any;
  inputValue: string;
  placeholder?: string;
  onFocus?: any;
  onBlur?: any;
  extraCss?: string;
  labelStyles?: React.CSSProperties;
  disabled?: boolean;
  maxLength?: string;
  inputMode?: string;
  pattern?: string;
}

const ranges = [
  "\ud83c[\udf00-\udfff]", // U+1F300 to U+1F3FF
  "\ud83d[\udc00-\ude4f]", // U+1F400 to U+1F64F
  "\ud83d[\ude80-\udeff]", // U+1F680 to U+1F6FF
];

function removeEmoji(str) {
  let strCopy = str;
  const emojiKeycapRegex = /[\u0023-\u0039]\ufe0f?\u20e3/g;
  const emojiRegex = /\p{Extended_Pictographic}/gu;
  const emojiComponentRegex = /\p{Emoji_Component}/gu;
  if (emojiKeycapRegex.test(strCopy)) {
    strCopy = strCopy.replace(emojiKeycapRegex, "");
  }
  if (emojiRegex.test(strCopy)) {
    strCopy = strCopy.replace(emojiRegex, "");
  }
  if (emojiComponentRegex.test(strCopy)) {
    // eslint-disable-next-line no-restricted-syntax
    for (const emoji of strCopy.match(emojiComponentRegex) || []) {
      if (/[\d|*|#]/.test(emoji)) {
        continue;
      }
      strCopy = strCopy.replace(emoji, "");
    }
  }

  return strCopy;
}

const FloatingInput: FC<IFloatInputProps> = ({
  type,
  id,
  name,
  labelName,
  onChange,
  inputValue,
  className,
  onFocus = () => {},
  extraCss,
  onBlur = () => {},
  placeholder,
  labelStyles,
  disabled = false,
  maxLength,
  inputMode,
  pattern,
}) => {
  const [val, setVal] = useState(inputValue || "");

  const refInputPass = useRef();
  const [placehold, setPlacehold] = useState("");

  useEffect(() => {
    if (placeholder) {
      setPlacehold(placeholder);
    }
    if (id === "aadhaarNum") {
      inputValue = addSpaceToNumber(inputValue, 4);
    }
    setVal(inputValue);
  }, [placeholder, inputValue]);

  const handleInput = (evt) => {
    if (type === "tel") {
      setVal(evt.target.value.replace(/[^0-9]/g, "").replace(/(\..*)\./g, ""));
      onChange(
        evt.target.value.replace(/[^0-9]/g, "").replace(/(\..*)\./g, "")
      );
    }
  };

  const handlechange = (evt) => {
    if (type === "number") {
      if (maxLength == "6") {
        const maxInputRegex = /^[0-9]{0,6}$/;
        if (maxInputRegex.test(evt.target.value)) {
          setVal(evt.target.value);
          onChange(evt.target.value);
        }
      } else if (maxLength == "9") {
        const maxInputRegex = /^[0-9]{0,9}$/;
        if (maxInputRegex.test(evt.target.value)) {
          setVal(evt.target.value);
          onChange(evt.target.value);
        }
      }
      else if (maxLength == '10') {
        const maxInputRegex = /^[0-9]{0,10}$/;
        if (maxInputRegex.test(evt.target.value)) {
          setVal(evt.target.value);
          onChange(evt.target.value);
        }
      } else {
        const maxInputRegex = /^[0-9]{0,10}$/;
        if (maxInputRegex.test(evt.target.value)) {
          setVal(evt.target.value);
          onChange(evt.target.value);
        }
      }
    } else if (type === "tel") {
    } else if (id === "dob") {
      var date_regex = new RegExp("^[0-9/]+$|^$");
      if (date_regex.test(evt.target.value) && evt.target.value.length <= 10) {
        setVal(evt.target.value);
        onChange(evt);
      }
    } else if (id === "username") {
      var name_regex = /^^$|[A-Za-z0-9 ]$/;
      if (name_regex.test(evt.target.value)) {
        setVal(evt.target.value);
        onChange(evt);
      }
    } else if (id === "cvv") {
      const maxInputRegex = /^[0-9]{0,3}$/;
      if (maxInputRegex.test(evt.target.value)) {
        setVal(evt.target.value);
        onChange(evt.target.value);
      }
    } else if (id === "ccnum") {
      const maxInputRegex = /^[0-9 ]{0,19}$/;
      if (maxInputRegex.test(evt.target.value)) {
        setVal(evt.target.value);
        onChange(evt.target.value);
      }
    } else if (id === "ccexp") {
      var exp_regex = /^[0-9/ ]{0,5}$/;
      if (exp_regex.test(evt.target.value)) {
        setVal(evt.target.value);
        onChange(evt.target.value);
      }
    } else if (id === "full_name") {
      var name_regex = /^[a-zA-Z\s]*$/;
      if (name_regex.test(evt.target.value)) {
        setVal(evt.target.value);
        onChange(evt);
      }
    } else if (id === "exchange_partner") {
      var name_regex = /^[a-zA-Z0-9\s]*$/;
      if (name_regex.test(evt.target.value)) {
        setVal(evt.target.value);
        onChange(evt);
      }
    }else if (id === "custom_vendor" || id === "custom_brand" || id === "custom_model" || id === "custom_variant" || id === "custom_color") {
    let alphanumeric_regex = /^[a-zA-Z0-9\s]*$/;
    if (alphanumeric_regex.test(evt?.target?.value)) {
      setVal(evt?.target?.value);
      onChange(evt);
    }
  } else if (id === "aadhaarNum") {
      const updatedVal = addSpaceToNumber(evt.target.value, 4);
      setVal(updatedVal);
      onChange(updatedVal);
    } else if (id === "email") {
      const emailValue = evt.target.value.replace(
        /[^\p{L}\p{N}\p{P}\p{Z}{^$=+±\\'|`\\~<>}]/gu,
        ""
      );
      setVal(emailValue);
      onChange(evt, emailValue);
    } else if (id === "machineId") {
      var machine_regex = /^[a-zA-Z0-9\s]*$/;
      if (machine_regex.test(evt.target.value)) {
        setVal(evt.target.value);
        onChange(evt);
      }
    } else if (id === "uniqueID") {
      var uniqueCoderegX = /^[a-zA-Z0-9\s]*$/;
      if (uniqueCoderegX.test(evt.target.value)) {
        setVal(evt.target.value);
        onChange(evt);
      }
    } else if (id === "orderId") {
      var uniqueCoderegX = /^[a-zA-Z0-9\s]*$/;
      if (uniqueCoderegX.test(evt.target.value)) {
        setVal(evt.target.value);
        onChange(evt);
      }
    } else if (id == "currency-IN") {
      if (evt.target.value) {
        let value = evt.target.value;
        value = value.replace(/[^0-9 ]/g, "");
        value = value.replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
        value = "₹" + value;
        setVal(value);
        onChange(value);
      } else {
        setVal("");
        onChange("");
      }
    } else if (id == "registrationNo") {
      let value = evt.target.value;
      if (value) {
        value = value.replace(/([^\w]+|\s+)/g, "");
        setVal(value);
        onChange(value);
      } else {
        setVal("");
        onChange("");
      }
    } else {
      setVal(evt.target.value);
      onChange(evt);
    }
  };

  const inputPasswordFocus = () => {
    if (className === "password-input-error") {
      const myInputContainer = document.getElementById("refInputContainer");
      if (myInputContainer) {
        myInputContainer.style.border = "10px solid yellow !important";
      }
    }
  };

  const inputFocussed = () => {
    onFocus();
    setPlacehold("");
  };
  const typeNumberCheck = ["e", "E", "+", "-", "."];

  let otherAttributes: any = {};

  if (inputMode) {
    otherAttributes.inputMode = inputMode;
  }

  if (pattern) {
    otherAttributes.pattern = pattern;
  }

  return (
    <div
      id="refInputContainer"
      onFocus={inputPasswordFocus}
      className={`material-textfield ${className}`}
    >
      <input
        id={id ? id : ""}
        name={name ? name : ""}
        style={{ border: "none" }}
        autoComplete="off"
        placeholder={placehold}
        keyboardType="ascii-capable"
        type={type}
        value={val}
        onKeyDown={(evt) =>
          type === "number" &&
          typeNumberCheck.includes(evt.key) &&
          evt.preventDefault()
        }
        onInput={handleInput}
        onChange={handlechange}
        onFocus={inputFocussed}
        onBlur={onBlur}
        className={extraCss ? extraCss : ""}
        disabled={disabled}
        maxLength={maxLength ? maxLength : ""}
        {...otherAttributes}
      />
      <label style={{ ...labelStyles }} className={`inputLabel`}>
        {labelName}
      </label>
    </div>
  );
};

export default FloatingInput;
